import React, { Component } from 'react';
//import logo from '../../images/logo.png';
import { Dropdown, Icon, Menu, Label, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { deleteJwt, getUserName } from '../utils/auth';
import { logout } from '../utils/rest';
import Chat from '../components/Chat';
class Header extends Component {

  logout = () => {
    logout().then((response) => {
      deleteJwt();
      this.props.logout();
      localStorage.clear(); //for localStorage
      sessionStorage.clear(); //for sessionStorage
      this.props.history.push("/");
    })
  }

  componentDidUpdate(prevProps) {
    if (this.props.items.notification !== prevProps.items.notification) {
      return true;
    }
    return false;
  }

  order = (a, b) => {
    let comparison = 0;
    if (a.order > b.order) {
      comparison = 1;
    } else if (a.order < b.order) {
      comparison = -1;
    }
    return comparison;
  }


  render() {

    const menuItems = this.props.menuitems;
    const compare = this.order;
    const style = {
      position: 'absolute',
      top: '5px',
      left: '52px',
      padding: '3px'
    }
    const trigger = (
      <span data-inverted data-position="left center" data-tooltip={getUserName()}>
        <Icon className='users' />
      </span>
    )
    const mailNotification = () => {
      let count = null;
      if (this.props.items.notification.inbox) {
        count = (<Label className='red small' floating style={style}>{this.props.items.notification.inbox}</Label>)
      }
      return (
        <Menu.Item as={Link} to="/mails">
          <Icon className="large mail" />{count}
        </Menu.Item>
      )
    }

    const alertNotification = () => {
      let count = null;
      if (this.props.items.countDetails.alertCount) {
        count = (<Label className='red small' floating style={style}>{this.props.items.countDetails.alertCount}</Label>)
      }
      return (
        <Menu.Item as={Link} to="/alert">
          <Icon className="large bell" />{count}
        </Menu.Item>)
    }

    const chatComponenet = () => {
      if (this.props.config.CHAT_LINK) {
        return (
          <Menu.Item style={{ cursor: "pointer" }}>
            <Chat CHAT_LINK={this.props.config.CHAT_LINK} />
          </Menu.Item>)
      }
    }


    let mainMenus = menuItems.map(function (menuItem, i) {
      if (menuItem.parent !== 'Others' && menuItem.child !== undefined) {
        return (
          <Dropdown key={i} text={menuItem.parent} className='item simple' open={false}>
            <Dropdown.Menu>
              {menuItem.child.sort(compare).map(function (child, j) {
                return (
                  <Dropdown.Item key={j} as={Link} to={child.url}> {child.icon && child.icon.length > 0 ? <Icon name={child.icon} /> : ""} {child.menu}</Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          </Dropdown>
        )
      } else {
        return null;
      }
    });

    // eslint-disable-next-line
    let logoutMenus = menuItems.map(function (menuItem, i) {
      if (menuItem.parent === 'Others' && menuItem.child !== undefined) {
        return (
          <Dropdown key={i} trigger={trigger} className='item right simple' open={false}>
            <Dropdown.Menu>
              {menuItem.child.sort(compare).map(function (child, j) {
                return (
                  <Dropdown.Item key={j} as={Link} to={child.url}> {child.icon && child.icon.length > 0 ? <Icon name={child.icon} /> : ""} {child.menu}</Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          </Dropdown>
        )
      } else {
        return null;
      }
    });


    return (
      <div>
        <Menu className="small fixed">
          {/* Logo */}
          <Menu.Item className="logo" as={Link} to={"/home"}><Image src={(this.props.config.LOGO ? this.props.config.LOGO : require("../../images/logo.png"))} alt="CLIENT PORTAL" /></Menu.Item>
          {/* End Logo */}
          <Menu.Item className="active" as={Link} to={"/home"}><Icon className="home" /></Menu.Item>
          {mainMenus}
          {mailNotification()}
          {alertNotification()}
          {chatComponenet()}
          {/*{logoutMenus}*/}
          <Dropdown trigger={trigger} className='item right'>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to="/profile">{this.props.t("update.profile")}</Dropdown.Item>
              <Dropdown.Item as={Link} to="/changepassword">{this.props.t("change.password")}</Dropdown.Item>
              <Dropdown.Item as={Link} to="/userguide">{this.props.t("user.guide.getting.started")}</Dropdown.Item>
              <Dropdown.Item as={Link} to="/keyword">{this.props.t("keyword.library")}</Dropdown.Item>
              <Dropdown.Item as={Link} to="/globalguide">{this.props.t("global.guide")}</Dropdown.Item>
              <Dropdown.Item as={Link} to="/CHANGELOG">{this.props.t("changelog")}</Dropdown.Item>
              <Dropdown.Item onClick={this.logout}>{this.props.t("logout")}</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Menu>
      </div>
    );
  }
}
export default Header;



// WEBPACK FOOTER //
// ./src/app/layout/Header.js